import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { changeRemoteExtractRefreshExpectedDuration } from '../actions/ChangeRemoteExtractRefreshExpectedDurationAction';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';

export const ChangeRemoteExtractRefreshExpectedDurationEntityAction:
  IEntityAction<IRemoteRefreshScheduleInfo, any> = {
  name: EntityActionNames.TasksEditExpectedDuration,
  translateName: Messages.editRemoteRefreshExpectedDuration_action,
  isVisible: () => { return true; },
  isClickable: isClickable,
  createReduxAction: (items: IRemoteRefreshScheduleInfo[]) => changeRemoteExtractRefreshExpectedDuration(items[0])
};

function isClickable(
  availableActions: any,
  schedules: IRemoteRefreshScheduleInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsOwnerOrAdmin(state, spaceItem);
}
